import { withRouter, RouteComponentProps } from 'react-router-dom';
import RNIntegration from '../../lib/RNIntegration';
import AnalyticsHelper from '../../lib/AnalyticsHelper';

const HistoryNotifyer = ({ history, location }: RouteComponentProps<void>) => {
    AnalyticsHelper.trackPageView(location.pathname);

    history.listen(() => {
        RNIntegration.notifiyHistoryChanged();
    });

    return null;
};

export default withRouter(HistoryNotifyer);
